import { render } from "./list.vue?vue&type=template&id=a0d16530&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=a0d16530&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0d16530"],['__file',"src/views/alfmeier/advertise/list.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a0d16530"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a0d16530', __exports__)) {
    console.log('reload')
    api.reload('a0d16530', __exports__)
  }
  
  module.hot.accept("./list.vue?vue&type=template&id=a0d16530&scoped=true", () => {
    console.log('re-render')
    api.rerender('a0d16530', render)
  })

}


export default __exports__